<template>
  <div id="glass-units-page" class="disable-dbl-tap-zoom">
    <v-toolbar color="blue">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="filter"
        @input="isChangingFilter = true"
        hide-details
        prepend-icon="search"
        clearable
        single-line
        autofocus
      ></v-text-field>
    </v-toolbar>
    <div class="progress-wrapper">
      <v-progress-linear :indeterminate="loading"></v-progress-linear>
    </div>
    <div class="glass-units-content">
      <GlassUnitsMobile
        v-if="mobile"
        ref="glassUnitsMobile"
        :glassUnits="glassUnits"
        :total="total"
        @pageChanged="changePage"
      />
      <GlassUnitsTable
        ref="glassUnitsTable"
        v-else
        :glassUnits="glassUnits"
        @pageChanged="changePage"
        @sortChanged="changeSort"
      />
    </div>
    <div class="add-button">
      <input
        type="file"
        id="files"
        ref="files"
        accept="application/vnd.ms-excel"
        multiple
        @change="handleFilesUpload"
      />
      <v-btn fab large dark color="indigo" @click="selectFiles">
        <v-icon dark>add</v-icon>
      </v-btn>
    </div>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list class="pa-1">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img src="http://www.dge-group.lt/wp-content/uploads/2018/08/arlanga-pvc-uab.png" />
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{user.name}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-list class="pt-0" dense>
        <v-divider></v-divider>

        <v-list-tile>
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>

          <v-list-tile-content class="logout-button" @click="logout">
            <v-list-tile-title>Atsijungti</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-snackbar v-model="snackbar" :color="color" :timeout="5000">
      {{ statusText }}
      <v-btn dark flat @click="snackbar = false">Uždaryti</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import User from "@/models/User.js";
import Helper from "@/models/Helper.js";
import GlassUnit from "@/models/GlassUnit.js";
import GlassUnitsTable from "@/components/glass-units-module/GlassUnitsTable.vue";
import GlassUnitsMobile from "@/components/glass-units-module/GlassUnitsMobile.vue";
export default {
  name: "glass-units-page",
  data() {
    return {
      loading: false,
      filter: "",
      glassUnits: [],
      color: "error",
      snackbar: false,
      drawer: null,
      user: new User(this.$session.get("user")),
      statusText: "",
      mobile: Helper.isMobile(),
      isChangingFilter: false,
      filterTimer: 0,
      page: 1,
      sortBy: "stand_number",
      descending: false,
      total: 0,
    };
  },
  created() {
    this.initialize();
  },
  watch: {
    isChangingFilter(val) {
      if (!val) {
        this.page = 1;
        this.initialize();
      }
    },
    filter() {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.isChangingFilter = false;
      }, 500);
      if (this.filter == "") {
        this.filter = null;
      }
    },
  },
  methods: {
    async initialize() {
      this.loading = true;
      const { units, pages, total } = await GlassUnit.getGlassUnits(
        this.filter,
        this.page,
        this.descending ? "desc" : "asc",
        this.sortBy
      );
      this.glassUnits = units;
      this.total = total;
      if (this.mobile) {
        this.$refs.glassUnitsMobile.updatePages(pages, this.page);
      } else {
        this.$refs.glassUnitsTable.updatePages(pages, this.page);
      }
      this.loading = false;
    },

    changePage(page) {
      this.page = page;
      this.initialize();
    },

    changeSort(sort) {
      this.descending = sort.descending;
      this.sortBy = sort.sort_by;
      this.initialize();
    },

    logout() {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
      this.$router.go();
    },

    selectFiles() {
      document.getElementById("files").click();
    },

    async handleFilesUpload() {
      const files = this.$refs.files.files;
      let success = 0;
      if (files) {
        success = await GlassUnit.upload(files);
      }
      switch (success) {
        case 0:
          this.color = "error";
          this.statusText = "Klaida keliant failus";
          this.snackbar = true;
          break;
        case 1:
          this.color = "success";
          this.statusText = "Failai sėkmingai įkelti";
          this.snackbar = true;
          break;
      }
      document.getElementById("files").value = "";
      this.initialize();
    },
  },
  components: {
    GlassUnitsTable,
    GlassUnitsMobile,
  },
};
</script>

<style scoped>
.header {
  background: rgb(21, 194, 224);
  height: 3em;
}
.logout-button {
  cursor: pointer;
}
.add-button {
  position: fixed;
  bottom: 5em;
  right: 3em;
}
.add-button:focus {
  outline: none;
  border: none;
}
.disable-dbl-tap-zoom {
  touch-action: manipulation;
}
#files {
  display: none;
}
.progress-wrapper {
  position: relative;
  top: -15px;
}
</style>